<div>

  <h2 class="page-header left">Remitos Pendientes de Retorno</h2>

  <form class="form-container" appearance="outline" [formGroup]="openItemsReportForm" #formDirective="ngForm" autocomplete="off">
    <div class="row row-spacing">
      <div style="text-align:right;">
        <button mat-icon-button class="view-remito-buttons" (click)="printOpenRemitos()" [disabled]="isLoading">
          <mat-icon *ngIf="!isLoading">print</mat-icon>
          <mat-spinner *ngIf="isLoading" class="loading-spinner-small" diameter="15"></mat-spinner>
        </button>
        <button mat-icon-button class="view-remito-buttons" (click)="search()"><mat-icon>pageview</mat-icon></button>
      </div>
    </div>
    <mat-divider class="mat-divider-header"></mat-divider>
    <div class="row row-spacing">

      <div class="col-lg-3 col-md-7 col-sm-12 col-xs-12">
        <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
          <mat-label>Solicitante</mat-label>
          <input type="text" matInput [formControl]="solicitanteControl" [matAutocomplete]="autoSolicitante">
          <mat-autocomplete #autoSolicitante="matAutocomplete">
            <mat-option *ngFor="let solicitante of filteredSoilicitante | async"
                        [value]="solicitante.idSolicitante + ' - ' + solicitante.solicitante">
              {{ solicitante.idSolicitante }} - {{ solicitante.solicitante }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>


      <div class="col-lg-5 col-md-10 col-sm-12 col-xs-12">
        <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
          <mat-label>Almacen</mat-label>
          <fab-multiselect
            id="almacenSelect"
            placeholder="Almacen"
            name="Almacen"
            [options]=almacenOptions
            [formControl]="almacenControl"
            (ngModelChange)="onChangeAlmacen($event)">
          </fab-multiselect>
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-7 col-sm-12 col-xs-12">
        <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
          <mat-label>Fec A Retornar</mat-label>
          <input matInput [matDatepicker]="fecARetornar" [formControl]="fecARetornarControl">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="fecARetornar"></mat-datepicker-toggle>
          <mat-datepicker #fecARetornar></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Table -->
  <div class="table-height table-flex" *ngIf="showReportData">
    <table mat-table matSort [dataSource]="dataSource">

      <!-- Almacen Column -->
      <ng-container matColumnDef="almacen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Almacen
          <rem-string-filter #tableFilter columnDef="almacen" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element">  {{ element.almacen }} </td>
      </ng-container>

      <!-- Origen Column -->
      <ng-container matColumnDef="origen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Origen
          <rem-string-filter #tableFilter columnDef="origen" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element">  {{ element.origen }} </td>
      </ng-container>

      <!-- PTO Emission Column -->
      <ng-container matColumnDef="ptoEmision">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> PTO Emision
          <rem-string-filter #tableFilter columnDef="ptoEmision" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.ptoEmision}} </td>
      </ng-container>

      <!-- Nro Remito Column -->
      <ng-container matColumnDef="nroRemito">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> NRO RTO
          <rem-string-filter #tableFilter columnDef="nroRemito" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element">  {{ element.nroRemito }} </td>
      </ng-container>

      <!-- Fec Gen Column -->
      <ng-container matColumnDef="fecGen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Gen
          <rem-date-filter #tableFilter columnDef="fecGen" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.fecGen | customDate}} </td>
      </ng-container>

      <!-- Fec a Retornar Column -->
      <ng-container matColumnDef="fecARetornar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec a Retornar
          <rem-date-filter #tableFilter columnDef="fecARetornar" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element"  class="center"> {{element.fecARetornar | customDate}} </td>
      </ng-container>

      <!-- Fec Salida Column -->
      <ng-container matColumnDef="fecSalida">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Salida
          <rem-date-filter #tableFilter columnDef="fecSalida" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element"  class="center"> {{element.fecSalida | customDate}} </td>
      </ng-container>

      <!-- Cant Prorrogas Column -->
      <ng-container matColumnDef="cantProrrogas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cant Prorrogas
          <rem-string-filter #tableFilter columnDef="cantProrrogas" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element">  {{ element.cantProrrogas }} </td>
      </ng-container>

      <!-- Ult Fec Prorroga Column -->
      <ng-container matColumnDef="ultFecProrroga">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ult Fec Prorroga
          <rem-date-filter #tableFilter columnDef="ultFecProrroga" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element"  class="center"> {{element.ultFecProrroga | customDate}} </td>
      </ng-container>

      <!-- Motivo Column -->
      <ng-container matColumnDef="motivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Motivo
          <rem-string-filter #tableFilter columnDef="motivo" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="left" *matCellDef="let element"> {{element.motivo}} </td>
      </ng-container>

      <!-- Dock Column -->
      <ng-container matColumnDef="dock">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Dock
          <rem-string-filter #tableFilter columnDef="dock" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.dock}} </td>
      </ng-container>

      <!-- Solicitante Column -->
      <ng-container matColumnDef="solicitante">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Solicitante
          <rem-string-filter #tableFilter columnDef="solicitante" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-xltext" *matCellDef="let element"> {{element.solicitante}} </td>
      </ng-container>

      <!-- Destino Column -->
      <ng-container matColumnDef="destino">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destino
          <rem-string-filter #tableFilter columnDef="destino" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.destino}} </td>
      </ng-container>

      <!-- Transporte Column -->
      <ng-container matColumnDef="transporte">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transporte
          <rem-string-filter #tableFilter columnDef="transporte" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.transporte}} </td>
      </ng-container>

      <!-- Commentario Column -->
      <ng-container matColumnDef="comentario">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Commentario
          <rem-string-filter #tableFilter columnDef="comentario" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="left" *matCellDef="let element"> {{element.comentario}} </td>
      </ng-container>

      <!-- Nro Ticket Column -->
      <ng-container matColumnDef="nroTicket">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro Ticket
          <rem-string-filter #tableFilter columnDef="nroTicket" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.nroTicket}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator #paginator
                 [pageSize]="10"
                 [pageSizeOptions]="[10, 15, 20, 25]"
                 [hidden]="!dataSource.data.length">
  </mat-paginator>
</div>
